import { render, staticRenderFns } from "./ModalCompletePublish.vue?vue&type=template&id=5af54bc4&scoped=true&"
import script from "./ModalCompletePublish.vue?vue&type=script&lang=ts&"
export * from "./ModalCompletePublish.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCompletePublish.vue?vue&type=style&index=0&id=5af54bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af54bc4",
  null
  
)

export default component.exports